import React from "react";

const CampaignsLoading = () => {
  return (
    <div className="overflow-x-auto rounded-xl border border-gray-800 bg-gray-900">
      <table className="w-full min-w-[700px]" style={{ tableLayout: "fixed" }}>
        <colgroup>
          <col style={{ width: "40%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "30%" }} />
        </colgroup>
        <thead>
          <tr className="border-b border-gray-800">
            <th className="px-4 py-4 text-left sm:px-6">
              <div className="h-3 w-28 animate-pulse rounded bg-gray-700" />
            </th>
            <th className="px-4 py-4 text-left sm:px-6">
              <div className="h-3 w-12 animate-pulse rounded bg-gray-700" />
            </th>
            <th className="px-4 py-4 text-center sm:px-6">
              <div className="mx-auto h-3 w-14 animate-pulse rounded bg-gray-700" />
            </th>
            <th className="px-6 py-4 text-center">
              <div className="mx-auto h-3 w-40 animate-pulse rounded bg-gray-700" />
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-800/50">
          {[...Array(5)].map((_, index) => (
            <tr key={index}>
              {/* Campaign Name */}
              <td className="overflow-hidden px-4 py-4 sm:px-6">
                <div className="animate-pulse space-y-2">
                  <div className="h-4 w-32 rounded bg-gray-700 sm:w-40" />
                  <div className="h-3 w-24 rounded bg-gray-700 sm:w-28" />
                </div>
              </td>

              {/* Type */}
              <td className="px-4 py-4 sm:px-6">
                <div className="flex animate-pulse items-center space-x-2">
                  <div className="h-4 w-4 rounded bg-gray-700" />
                  <div className="h-4 w-12 rounded bg-gray-700 sm:w-14" />
                </div>
              </td>

              {/* Status */}
              <td className="px-4 py-4 text-center sm:px-6">
                <div className="mx-auto h-6 w-14 animate-pulse rounded-full bg-gray-700" />
              </td>

              {/* Performance (Open Rate / CTR) */}
              <td className="px-6 py-4">
                <div className="flex animate-pulse items-center justify-center">
                  <div className="space-y-1 px-4">
                    <div className="mx-auto h-4 w-14 rounded bg-gray-700" />
                    <div className="mx-auto h-3 w-16 rounded bg-gray-700" />
                  </div>
                  <div className="h-8 border-r border-gray-500"></div>
                  <div className="space-y-1 px-4">
                    <div className="mx-auto h-4 w-14 rounded bg-gray-700" />
                    <div className="mx-auto h-3 w-8 rounded bg-gray-700" />
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CampaignsLoading;
